// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oUFY","icon":"styles_icon__2kd_A"};